import moment from 'moment';
import { ProjectRPCSession } from '#/services/session';
import { FreshEntityListRequest } from '#/services/entities/requests';
import { queryProjectClient } from '#/clients';
import { EntitiesSearchParameters, QueryString, QueryDate } from '#/protobuf/query_pb';
import { EntityType } from '#/protobuf/enums_pb';

// eslint-disable-next-line import/prefer-default-export
export class EntityListSession extends ProjectRPCSession {
  constructor(account, project) {
    super(account, project);

    this.request = FreshEntityListRequest();
    this.entities = [];

    this.resetPageData();
  }

  resetPageData() {
    this.entities.length = 0; // empty without setting to new array for any watchers

    this.loading = false; // a request is open over the wire
    this.loadedFirstPage = false; // have we loaded a page yet
    this.loadedLastPage = false; // have we loaded the last page yet

    this.pageCursor = 0; // current page
    this.pageSize = 15; // num items per page

    this.errorMessage = undefined;
  }

  setVideoFilter() {
    const videoSearchTerms = new EntitiesSearchParameters();
    videoSearchTerms.setEntityType(EntityType.ENTITY_TYPE_VIDEO);
    this.request.setSearchTerms(videoSearchTerms);
  }

  setAudioFilter() {
    const audioSearchTerms = new EntitiesSearchParameters();
    audioSearchTerms.setEntityType(EntityType.ENTITY_TYPE_AUDIO);
    this.request.setSearchTerms(audioSearchTerms);
  }

  setImageFilter() {
    const imageSearchTerms = new EntitiesSearchParameters();
    imageSearchTerms.setEntityType(EntityType.ENTITY_TYPE_IMAGE);
    this.request.setSearchTerms(imageSearchTerms);
  }

  async loadPage() {
    if (this.loading || this.loadedLastPage) {
      return false;
    }
    this.loading = true;
    console.info('loading entities list', this.pageCursor);

    this.request.setCursor(this.pageCursor);

    // TODO: abstract the header try/catch handling in in parent class
    const headers = await this.headers();
    return new Promise((resolve, reject) => {
      queryProjectClient.listEntities(this.request, headers, (err, response) => {
        if (err != null) {
          console.log('received err from listEntities ', err);
          this.error = err;
          return reject(err);
        }

        const r = response.toObject();
        console.log('promise resolved entities list: ', r);
        this.entities.push(...r.entitiesList);
        this.pageCursor = r.nextCursor;
        console.log('PAGE CURSOR', this.pageCursor);
        if (this.pageCursor === -1) {
          console.log('entities fully loaded');
          this.loadedLastPage = true;
        }
        return resolve();

        // TODO: commit mutations on store to set jobs

        // return resolve(response.toObject());
      });
    }).catch((error) => {
      console.warn('error listing entities', error);
      this.errorMessage = error.message !== '' ? error.message : 'Whoops... Something went wrong.';
    }).finally(() => {
      if (!this.loadedFirstPage) {
        this.loadedFirstPage = true;
      }
      this.loading = false;
    });
  }

  async filterSearch(searchTerm, filterDateStart, filterDateFinish) {
    if (!searchTerm && !filterDateStart && !filterDateFinish) {
      return;
    }

    const queryString = new QueryString();
    queryString.setSearchExact(searchTerm);
    const entitySearchParams = new EntitiesSearchParameters();
    entitySearchParams.setJobName(queryString);
    const queryDate = new QueryDate();

    const newDate = moment(filterDateStart, 'YYYY-MM-DD');
    const formatedDate = newDate.format(); // will return an ISO representation of the date
    console.info(formatedDate);
    queryDate.setSearchExact(formatedDate);
    entitySearchParams.setJobDateFinished(queryDate);
    this.request.setSearchTerms(entitySearchParams);
  }
}
